// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"73e279fe","176":"78bd8b08","253":"5672f896","427":"f0251cef","452":"43cb273c","535":"201e8b3e","634":"8777af09","673":"d053f006","984":"5a9dbbcb"}[chunkId] + ".chunk.css";
};